export default __webpack_public_path__ + "static/media/borkuIcon.e797b290.png";